import { CornersStyle } from "./types";
export var CORNERS_STYLES = Object.values(CornersStyle);
export var defaultProps = {
  cornersStyle: CornersStyle.Default,
  backgroundColor: 'transparent',
  textColor: 'inherit'
};